import React from 'react';

interface NumericKeypadProps {
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  maxLength?: number;
}

const NumericKeypad: React.FC<NumericKeypadProps> = ({ 
  value, 
  onChange, 
  onClose, 
  maxLength = 15 
}) => {
  const handleNumberClick = (num: string) => {
    if (value.length < maxLength) {
      onChange(value + num);
    }
  };

  const handleBackspace = () => {
    onChange(value.slice(0, -1));
  };

  const handleClear = () => {
    onChange('');
  };

  const numbers = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9']
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-300 dark:border-gray-600 p-3 shadow-lg w-full">
      <div className="flex justify-between items-center mb-3">
        <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
          Enter Phone Number
        </span>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          aria-label="Close keypad"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <div className="grid grid-cols-3 gap-2">
        {numbers.map((row, _rowIndex) =>
          row.map((num, _colIndex) => {
            return (
              <button
                key={num}
                onClick={() => handleNumberClick(num)}
                className="aspect-square bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 active:bg-gray-300 dark:active:bg-gray-500 rounded-lg text-lg font-semibold text-gray-900 dark:text-white transition-colors touch-manipulation flex items-center justify-center shadow-sm"
                type="button"
              >
                {num}
              </button>
            );
          })
        )}
      </div>
      
      <div className="grid grid-cols-3 gap-2 mt-2">
        <button
          onClick={handleClear}
          className="aspect-square bg-red-100 dark:bg-red-900 hover:bg-red-200 dark:hover:bg-red-800 active:bg-red-300 dark:active:bg-red-700 rounded-lg text-xs font-medium text-red-700 dark:text-red-200 transition-colors touch-manipulation shadow-sm flex items-center justify-center"
          type="button"
        >
          Clear
        </button>
        <button
          onClick={() => handleNumberClick('0')}
          className="aspect-square bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 active:bg-gray-300 dark:active:bg-gray-500 rounded-lg text-lg font-semibold text-gray-900 dark:text-white transition-colors touch-manipulation flex items-center justify-center shadow-sm"
          type="button"
        >
          0
        </button>
        <button
          onClick={handleBackspace}
          className="aspect-square bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 active:bg-gray-300 dark:active:bg-gray-500 rounded-lg text-xs font-medium text-gray-700 dark:text-gray-300 transition-colors touch-manipulation flex items-center justify-center shadow-sm"
          type="button"
          aria-label="Backspace"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default NumericKeypad;

